import { Box, Typography } from "@mui/material";

import { Button } from "../../../components/Button";
import { UnifiedModal } from "../../../components/UnifiedModal";
import { META_PLATFORMS } from "./portalReturn";

/**
 * Shown before opening the portal. The network's consent screen names bundle.social
 * (its developer app), not Markezy. Facebook/Instagram: Meta keeps one grant per user.
 */
export function ConnectWarning({ open, platforms = [], onCancel, onConfirm }) {
  const isMeta = platforms.some((platform) => META_PLATFORMS.includes(platform));
  return (
    <UnifiedModal open={open} onClose={onCancel} title="Antes de conectar" maxWidth="sm">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="body2" sx={{ color: "#374151" }}>
          Publicamos a través de <strong>bundle.social</strong>, nuestro proveedor de publicación. En la
          pantalla de permisos, la red te pedirá autorizar a <strong>«bundlesocial»</strong> y te
          redirigirá a <strong>api.bundle.social</strong>: es normal, acepta los permisos.
        </Typography>
        {isMeta && (
          <>
            <Typography variant="body2" sx={{ color: "#374151" }}>
              En la pantalla de permisos de Facebook, marca <strong>todas</strong> las Páginas y cuentas de
              Instagram que gestionas, aunque sean de otros clientes.
            </Typography>
            <Typography variant="body2" sx={{ color: "#6B7280" }}>
              Meta guarda un único permiso por usuario: si marcas solo la de este cliente, las demás
              dejarán de poder publicar.
            </Typography>
          </>
        )}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5 }}>
          <Button variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
          <Button onClick={onConfirm}>Entendido, continuar</Button>
        </Box>
      </Box>
    </UnifiedModal>
  );
}
